export enum Evaluation {
    Documented = 1,
    AssessedSure = 2,
    Unsure = 3,
    ErroneousReport = 4,
}

export const defaultEvaluationFilter = [Evaluation.Documented, Evaluation.AssessedSure, Evaluation.Unsure];
